// ─────────────────────────────────────────────────────────────
// SharedFileService — shared_files 테이블 (작업파일 공유란)
// v7.312
//
// 파일 실체는 nginx WebDAV(/attachments/shared/) 에 있고,
// 이 테이블은 메타데이터(원본 파일명·크기·올린 사람)만 들고 있다.
// 스키마: migrations/v7.312-memo-images-shared-files.sql
//
// ⚠ 테이블이 없어도(SQL 미실행) 메모 탭 자체는 떠야 한다.
//   그래서 조회 실패를 던지지 않고 ok:false 로 돌려준다.
// ─────────────────────────────────────────────────────────────
import { supabase } from '../supabase';

export const SharedFileService = {
  async list() {
    try {
      const { data, error } = await supabase
        .from('shared_files')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) return { ok: false, msg: error.message, data: [] };
      return { ok: true, data: data || [] };
    } catch (e) {
      return { ok: false, msg: e.message || String(e), data: [] };
    }
  },

  async create({ name, path, size, mime, note, uploadedBy }) {
    try {
      const { data, error } = await supabase
        .from('shared_files')
        .insert({
          name, path,
          size: Number(size) || 0,
          mime: mime || null,
          note: note || null,
          uploaded_by: uploadedBy || null,
        })
        .select().single();
      if (error) return { ok: false, msg: error.message };
      return { ok: true, data };
    } catch (e) {
      return { ok: false, msg: e.message || String(e) };
    }
  },

  async remove(id) {
    try {
      const { error } = await supabase.from('shared_files').delete().eq('id', id);
      if (error) return { ok: false, msg: error.message };
      return { ok: true };
    } catch (e) {
      return { ok: false, msg: e.message || String(e) };
    }
  },

  async updateNote(id, note) {
    try {
      const { error } = await supabase.from('shared_files').update({ note: note || null }).eq('id', id);
      if (error) return { ok: false, msg: error.message };
      return { ok: true };
    } catch (e) {
      return { ok: false, msg: e.message || String(e) };
    }
  },
};
